import { Component, inject, OnInit } from '@angular/core';
import { NavbarService } from 'src/app/navbar.service';
import { ValidationService } from '../validation.service';

@Component({
    standalone: false,
    selector: 'bp-sandbox-controls',
    templateUrl: './controls.component.html',
    styleUrls: ['./controls.component.css'],
    
})
export class SandboxControlsComponent implements OnInit {
	model = {
		aText: 'Hallo',
		aDependentText: '',
		aNumber: 0.5,
		aFloat: 1.5765,
		aListText: 'Hallo',
		aDfListText: 'Hallo Dietmar',
		aListOption: '',
	};

	someOtherData = {
		magicText: 'Robert&Micha'
	};

	vs = inject(ValidationService);

	constructor() {
		const ns = inject(NavbarService);
		ns.componentTitle = 'Sandbox';
	}

	ngOnInit(): void {
		// Ein einfacher Validator
		// Dieser Validator könnte auch an zentraler Stelle (z.B. im ValidatorService-constructor)
		// registriert werden.
		this.vs.registerValidator("aText", (data) => {
			const txt = data as string;
			if (txt === 'Micha') return this.vs.danger("Hier soll man doch etwas anderes reinschreiben!");
			if (txt === 'Robert') return this.vs.message("Das ist ja wohl das Beste, was man hier reinschreiben kann!");
			if (parseFloat(txt).toString() === txt) return this.vs.warning("Bitte lieber einen Text reinschreiben, der keine Zahl ist");
			return this.vs.ok();
		});

		// Validator, der andere Daten der aktuellen Komponente verwendet (aText).
		// Dadurch muss dieser dort definiert werden, wo diese Daten auch verfügbar sind.
		this.vs.registerValidator("aDependentText", (txt) => {
			if (txt === this.model.aText) return this.vs.danger("Es sollte hier nicht das gleiche wie in aText stehen!");
			if (txt === '') return this.vs.warning("Gar kein Text ist aber nicht nett. Schreib mal lieber was rein.");
			if (txt === this.someOtherData.magicText) return this.vs.message("Du hast das Geheimnis geknackt!");
			return this.vs.ok();
		});
	}
}
